module.exports = __webpack_public_path__ + "img/customer_3_en.6c29097e.png";